import validatePaidCampaign from '@helpers/validatePaidCampaign';
import fetch from 'isomorphic-unfetch';
import React, { Component } from 'react';
import FooterComponent from '@/components/Footer/FooterComponent';
import Header from '@/components/Header/Header';
import SEOHead from '@/components/SEOHead/SEOHead';
import SpotlightHero from '@/components/SpotlightHero';
import SpotlightsComponent from '@/components/Spotlights/SpotlightsComponent';
import { WordPressAPI } from '../config';
import dynamic from 'next/dynamic';

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

class ClientSpotlight extends Component {
  render() {
    const { title, acf } = this.props.data;
    const paid_campaign = validatePaidCampaign(acf.paid_campaign);
    const additional_questions = acf.additional_questions;
    const { phone_number_setup } = acf;

    return (
      <div>
        <SEOHead>
          <title>{title.rendered}</title>
          <meta name="description" content={acf.meta_description} />
          <script
            type="text/javascript"
            src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
          />
        </SEOHead>
        <Header
          AdditionalQuestions={additional_questions}
          PaidCampaign={paid_campaign}
          phone_number={phone_number_setup}
        />
        <SpotlightHero
          title={acf.hero_title}
          copy={acf.hero_title_2}
          backgroundImage={acf.hero_background_image}
          image={acf.hero_image}
        />
        <SpotlightsComponent clients={acf.client} />
        {/* Email Newsletter */}
        <FooterNewsModal />
        <FooterComponent phone_number={phone_number_setup} />
      </div>
    );
  }
}

export const getStaticProps = async () => {
  const res = await fetch(`${WordPressAPI.pages}/324`);
  const data = await res.json();

  return {
    props: {
      data,
    },
    // revalidate: 1,
  };
};

export default ClientSpotlight;
